export default __webpack_public_path__ + "static/media/11.b28b1c8b.svg";